import { render, staticRenderFns } from "./UpdateAccountDialog.vue?vue&type=template&id=587b7a52&scoped=true&"
import script from "./UpdateAccountDialog.vue?vue&type=script&lang=js&"
export * from "./UpdateAccountDialog.vue?vue&type=script&lang=js&"
import style0 from "./UpdateAccountDialog.vue?vue&type=style&index=0&id=587b7a52&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "587b7a52",
  null
  
)

export default component.exports